import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaHome, FaUser, FaCog, FaChartBar, FaFileAlt, FaEnvelope, FaBox, FaLayerGroup } from "react-icons/fa";

const ICONS = [
    { id: "home", icon: <FaHome />, label: "Home" },
    { id: "user", icon: <FaUser />, label: "User" },
    { id: "cog", icon: <FaCog />, label: "Settings" },
    { id: "chart", icon: <FaChartBar />, label: "Chart" },
    { id: "file", icon: <FaFileAlt />, label: "File" },
    { id: "envelope", icon: <FaEnvelope />, label: "Mail" },
    { id: "box", icon: <FaBox />, label: "Product" },
    { id: "layer", icon: <FaLayerGroup />, label: "Layer" },
];

export default function MenuBuilderModal({ show, onHide, onSave, parentOptions = [] }) {
    const [label, setLabel] = useState("");
    const [path, setPath] = useState("");
    const [parentId, setParentId] = useState("");
    const [selectedIcon, setSelectedIcon] = useState("");
    const [isVisible, setIsVisible] = useState(true);
    const [openInNewTab, setOpenInNewTab] = useState(false);

    const handleSave = () => {
        if (!label) return;

        // Auto-generate path if empty
        const finalPath = path || `/${label.toLowerCase().replace(/\s+/g, "-")}`;

        onSave({
            label,
            path: finalPath,
            parentId,
            icon: selectedIcon,
            visible: isVisible,
            target: openInNewTab ? "_blank" : undefined
        });

        // Reset form
        setLabel("");
        setPath("");
        setParentId("");
        setSelectedIcon("");
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered className="premium-modal menu-builder-modal">
            <Modal.Header closeButton>
                <Modal.Title>Add Menu Item</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Label</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. Dashboard"
                                    value={label}
                                    onChange={(e) => setLabel(e.target.value)}
                                    autoFocus
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Path (URL)</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. /dashboard"
                                    value={path}
                                    onChange={(e) => setPath(e.target.value)}
                                />
                                <Form.Text className="text-muted">
                                    Leave empty to auto-generate from label.
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Parent Menu (Optional)</Form.Label>
                        <Form.Select value={parentId} onChange={(e) => setParentId(e.target.value)}>
                            <option value="">(Top Level)</option>
                            {parentOptions.map((opt) => (
                                <option key={opt.key} value={opt.key}>{opt.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Icon</Form.Label>
                        <div className="icon-grid">
                            {ICONS.map((item) => (
                                <div
                                    key={item.id}
                                    className={`icon-option ${selectedIcon === item.id ? "selected" : ""}`}
                                    onClick={() => setSelectedIcon(item.id)}
                                    title={item.label}
                                >
                                    {item.icon}
                                </div>
                            ))}
                        </div>
                    </Form.Group>

                    <div className="d-flex gap-4 mb-3">
                        <Form.Check
                            type="switch"
                            id="visibility-switch"
                            label="Visible"
                            checked={isVisible}
                            onChange={(e) => setIsVisible(e.target.checked)}
                        />
                        <Form.Check
                            type="switch"
                            id="newtab-switch"
                            label="Open in New Tab"
                            checked={openInNewTab}
                            onChange={(e) => setOpenInNewTab(e.target.checked)}
                        />
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button className="primary-gradient-btn" onClick={handleSave}>
                    Add Item
                </Button>
            </Modal.Footer>

            <style>{`
        .menu-builder-modal .icon-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
          gap: 10px;
          margin-top: 8px;
        }
        .menu-builder-modal .icon-option {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #ddd;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s;
          color: #666;
        }
        .menu-builder-modal .icon-option:hover {
          background: #f8f9fa;
          border-color: #bbb;
        }
        .menu-builder-modal .icon-option.selected {
          background: rgba(118, 75, 162, 0.1);
          border-color: #764ba2;
          color: #764ba2;
        }
      `}</style>
        </Modal>
    );
}
